import { Config } from 'config/envConfig';
import React, { useState, useEffect, useRef } from 'react';
import Maindbrepo from './maindbrepo';
import AddCloudRepo from './addCloudRepo';
import AddInternetRepo from './addInternetRepo';
import axios from 'axios';
import { Tabs } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChatsFeatures, isValidNamingRegex, ModelTiers } from '@quyva/common';
import {
    faCircleXmark,
    faExclamationTriangle,
    faFolderPlus,
    faPencil,
    faDatabase,
    faFile,
    faTable,
} from '@fortawesome/free-solid-svg-icons';
import {
    Button,
    DragDropFile,
    FileListViewer,
    Input,
    SubmitButton,
    alert,
    AlertType,
} from '@quyva/shared-ui';
import {
    vectorStores,
    Features,
    OtherFeatures,
    AddNewRepoFeatures,
    isFeatureEnabled,
} from '@quyva/common';
import { hasDuplicateNames, validateRepoName } from '@quyva/common';
import { ProcessType, Operation, RepoCreationPrompts } from '@quyva/common';
import { TaskProgressType } from '@quyva/common';
import { isMobile } from 'react-device-detect';
import { getUrl } from './pdfDisplay/utils';
import { useGlobalCredits } from '../context/GlobalStateContext.js';
import { RepoConfig } from './RepoConfig';
import { ImageResolution } from '../Constants';
import { useFeatureFlags } from '../context';
import { useRepoSubmit } from '../hooks/useRepoSubmit';

const ADD_REPO_PRIORITY = [
    AddNewRepoFeatures.ADD_FILE,
    AddNewRepoFeatures.ADD_DATABASE,
    AddNewRepoFeatures.ADD_INTERNET,
    AddNewRepoFeatures.ADD_CLOUD,
];

const CONTENT_REPO_FEATURES = [
    AddNewRepoFeatures.ADD_FILE,
    AddNewRepoFeatures.ADD_INTERNET,
    AddNewRepoFeatures.ADD_CLOUD,
];

const AddNewRepo = (props) => {
    const {
        availableCustomModels,
        isLoadingModels,
        selectedTier,
        customModel,
    } = useGlobalCredits();
    const { isSubmitting, runSubmit, WarningModal } =
        useRepoSubmit('repository creation');
    const imageResolutionList = Object.values(ImageResolution);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [error, setError] = useState('');
    const [repoDetails, setRepoDetails] = useState([]);
    const [imageResolution, setImageResolution] = useState(
        imageResolutionList[0]
    );
    const [imageResolutionDropdown, setImageResolutionDropdown] =
        useState(imageResolutionList);
    const [isDatabaseRepo, setIsDatabaseRepo] = useState(false);
    const [isCloudRepo, setIsCloudRepo] = useState(false);
    const [isInternetRepo, setIsInternetRepo] = useState(false);
    const [isTabularRepo, setIsTabularRepo] = useState(false);
    const [visionModel, setVisionModel] = useState(customModel);
    const [modelTierRepo, setModelTierRepo] = useState(selectedTier);
    const [organizationRepo, setOrganizationRepo] = useState(false);
    const [isPromptModalOpen, setIsPromptModalOpen] = useState(false);
    const { featureFlagsData } = useFeatureFlags();
    const [prompt, setPrompt] = useState({
        vision_representation: '',
    });

    const [lastPrompt, setLastPrompt] = useState({
        vision_representation: '',
    });
    const [availableEmbeddingModels, setAvailableEmbeddingModels] = useState(
        []
    );
    const [modelsLoading, setModelsLoading] = useState(true);
    const [embeddingModel, setEmbeddingModel] = useState(null); // will be set from backend default

    const fileInputRef = useRef(null);

    const user = JSON.parse(localStorage.getItem('current'));

    const [reponame, setreponame] = useState('');
    const [summary, setSummary] = useState(false);
    const [visionRepo, setVisionRepo] = useState(false);
    //Knowledge Graph
    const [knowledgeGraph, setKnowledgeGraph] = useState(false);

    const call = async () => {
        try {
            const dynamicUrl = getUrl(
                `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/repocount/${user.email}`
            );

            const response = await axios.get(dynamicUrl);
            return response.data.count;
        } catch (error) {
            console.log(error);
        }
    };

    function getDefaultCheckedFeature(priorityList, featureFlagsData) {
        // 1. Access the correct key (camelCase)
        const repoFlags = featureFlagsData?.addNewRepo;

        // 2. Return null if the data section doesn't exist
        if (!repoFlags) return null;

        return (
            priorityList.find(
                (feature) =>
                    // 3. Check if the flag is true for the current feature
                    repoFlags[feature] === true
            ) || null
        );
    }

    const [defaultCheck, setDefaultCheck] = useState(null);
    const [repoCategory, setRepoCategory] = useState('content');

    const DEFAULT_VALUE_BY_FEATURE = {
        [AddNewRepoFeatures.ADD_FILE]: 'file',
        [AddNewRepoFeatures.ADD_DATABASE]: 'database',
        [AddNewRepoFeatures.ADD_INTERNET]: 'internet',
        [AddNewRepoFeatures.ADD_CLOUD]: 'cloud',
    };

    const [featureValues, setFeatureValues] = useState(
        () => DEFAULT_VALUE_BY_FEATURE
    );

    function getFeatureValue(feature) {
        return featureValues[feature];
    }

    function getFirstEnabledContentFeature() {
        return (
            CONTENT_REPO_FEATURES.find((feature) =>
                isFeatureEnabled(
                    [Features.ADD_NEW_REPOSITORY, feature],
                    featureFlagsData
                )
            ) || AddNewRepoFeatures.ADD_FILE
        );
    }

    const hasAnyContentFeature = CONTENT_REPO_FEATURES.some((feature) =>
        isFeatureEnabled(
            [Features.ADD_NEW_REPOSITORY, feature],
            featureFlagsData
        )
    );

    useEffect(() => {
        const defaultFeature = getDefaultCheckedFeature(
            ADD_REPO_PRIORITY,
            featureFlagsData
        );
        const effectiveFeature =
            defaultFeature || getFirstEnabledContentFeature();
        const feature_value = getFeatureValue(effectiveFeature);
        setRepoCategory(
            effectiveFeature === AddNewRepoFeatures.ADD_DATABASE
                ? 'database'
                : 'content'
        );
        setDefaultCheck(effectiveFeature);
        handleChange(feature_value, effectiveFeature);
    }, [featureFlagsData]);

    // Case-insensitive and trimmed: the server treats those as the same repo.
    function isNameFound(searchString) {
        const target = String(searchString ?? '')
            .trim()
            .toLowerCase();
        if (!target) return false; // a blank name is never a collision
        return repoDetails.some(
            (repo) =>
                String(repo?.name ?? '')
                    .trim()
                    .toLowerCase() === target
        );
    }

    const repos = async () => {
        try {
            const dynamicUrl = getUrl(
                `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/getAllChatsRepos/${user.email}`
            );
            const authToken = encodeURIComponent(user.token);

            const headers = {
                Authorization: authToken,
                'Content-Type': 'application/json',
            };

            const response = await axios.get(dynamicUrl, { headers });
            setRepoDetails(response.data.Normal ?? []);
        } catch (error) {
            console.log(error);
        }
    };
    const fetchVisionInstruction = async (user) => {
        try {
            const url = getUrl(
                `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/prompts_routes/get-instruction`
            );

            const response = await axios.get(url, {
                params: {
                    process_enum: Operation.REPO_CREATION,
                    prompt_value: RepoCreationPrompts.VISION_REPRESENTATION,
                    email: user.email || null,
                    repoid: null, // or some id if you have one
                },
            });
            // Reformat response to the same structure as old backend
            const instructionData = response.data?.instruction || null;
            // Reformat into required structure
            const formattedResponse = {
                instructions: {
                    vision_representation: instructionData,
                },
            };
            return formattedResponse;
        } catch (error) {
            alert(AlertType.ERROR, error.message);
            return { vision_representation: '' };
        }
    };

    useEffect(() => {
        (async () => {
            const data = await fetchVisionInstruction(user);
            setPrompt(data);
        })();
    }, []);

    useEffect(() => {
        repos();
    }, []);

    useEffect(() => {
        let mounted = true;
        async function fetchEmbeddingModels() {
            setModelsLoading(true);
            try {
                const url = getUrl(
                    `http://${Config.FAST_API_HOST}:${Config.FAST_API_PORT}/embedding_routes/embedding-models`
                );
                // axios rejects on a non-2xx, so the explicit status check is redundant.
                const res = await axios.get(url);
                const data = res.data;
                if (!mounted) return;

                // server-driven models only (no frontend fallback)
                const models = Array.isArray(data.models) ? data.models : [];
                const def = data.default || null;

                setAvailableEmbeddingModels(models);
                // initialize embeddingModel only if not already set
                setEmbeddingModel((current) => current || def);
            } catch (err) {
                console.warn(
                    'Failed to load embedding models from server — NO frontend fallback. Models will be empty.',
                    err
                );
                // no fallback: empty list + null default
                setAvailableEmbeddingModels([]);
                setEmbeddingModel(null);
            } finally {
                if (mounted) setModelsLoading(false);
            }
        }
        fetchEmbeddingModels();
        return () => {
            mounted = false;
        };
    }, []);

    const handleFileSelect = (event) => {
        const files = Array.from(event.target.files);
        if (files.length > 0) {
            setSelectedFiles(files);
            setError('');
            validateFiles(files);
        }
    };

    const generateUniqueNumber = () => {
        const min = 10000;
        const max = 99999;
        const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        return randomNumber.toString();
    };

    const handleFileDrop = (event) => {
        event.preventDefault();
        const files = Array.from(event.dataTransfer.files);
        setSelectedFiles(files);
        setError('');
        validateFiles(files);

        // Programmatically set the files of the file input
        if (fileInputRef.current) {
            const dataTransfer = new DataTransfer();
            files.forEach((file) => dataTransfer.items.add(file));
            fileInputRef.current.files = dataTransfer.files;
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const validateFiles = (files) => {
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileType = file.type;
            const fileName = file.name.toLowerCase();
            if (
                !(
                    fileType === 'application/pdf' ||
                    fileType === 'text/plain' ||
                    fileType ===
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                    fileType === 'image/jpeg' ||
                    fileType === 'image/png' ||
                    fileName.endsWith('.md')
                )
            ) {
                setError(
                    'Only PDF, DOCX, text, JPEG, PNG and MD files are allowed.'
                );
                return;
            }

            if (hasDuplicateNames(files)) {
                setError('Duplicate file name found.');
                return;
            }
        }
    };

    const validateTabularFiles = (files) => {
        if (files.length > 1) {
            setError('Please upload only a single CSV or Excel file.');
            return false;
        }
        const name = files[0]?.name.toLowerCase() || '';
        if (
            !(
                name.endsWith('.csv') ||
                name.endsWith('.xlsx') ||
                name.endsWith('.xls')
            )
        ) {
            setError(
                'Only a single CSV or Excel (.csv, .xlsx, .xls) file is allowed.'
            );
            return false;
        }
        setError('');
        return true;
    };

    const handleTabularFileDrop = (event) => {
        event.preventDefault();
        const files = Array.from(event.dataTransfer.files);
        if (files.length > 0 && validateTabularFiles(files)) {
            setSelectedFiles(files);

            // Keep the hidden file input in sync with the dropped file
            if (fileInputRef.current) {
                const dataTransfer = new DataTransfer();
                files.forEach((file) => dataTransfer.items.add(file));
                fileInputRef.current.files = dataTransfer.files;
            }
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');

        if (selectedFiles.length === 0) {
            setError('Please select a file to upload!');
            return;
        }

        // Re-checked on submit: the name can also be set programmatically.
        const nameCheck = validateRepoName(reponame, repoDetails);
        if (!nameCheck.valid) {
            setError(nameCheck.error);
            return;
        }

        runSubmit(async () => {
            props.setViewNotifications(true);
            props.setAddNewMode(false);
            if (window.innerWidth < 1024) {
                props.closeSidebar();
            }

            const formData = new FormData();
            selectedFiles.forEach((file, index) => {
                formData.append(`file`, file);
            });
            formData.append('vision_instruction', JSON.stringify(prompt));
            try {
                const status = {
                    message: `Started repository creation with name ${reponame}`,
                    percentageCompletion: 0,
                    process: ProcessType.REPO_CREATION,
                    progress: TaskProgressType.STARTED,
                    repoId: null,
                    repoName: reponame,
                    statusCode: 200,
                    timeStamp: new Date(),
                    userMail: user.email,
                };

                props.socket.emit('statusUpdate', status);

                const dynamicUrl = getUrl(
                    `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}`
                );
                const val = (await call()) + 1;
                const un = generateUniqueNumber();

                const data = {
                    id: user.email,
                    val: val,
                    name: reponame,
                    un: un,
                    summary_flag: summary,
                    vector_store_type: vectorStores.QDRANT,
                    visionRepo: true,
                    knowledgeGraph: knowledgeGraph,
                    visionModel: visionModel,
                    embeddingModel: embeddingModel,
                    modelTier: modelTierRepo,
                    image_res: imageResolution,
                    org_id: organizationRepo ? props.organizationId : null,
                    repotype: isTabularRepo ? 'tabular' : 'content',
                };
                const data2 = JSON.stringify(data);
                const encodedToken = encodeURIComponent(user.token);

                await axios
                    .post(`${dynamicUrl}/new_upload/${data2}`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: encodedToken,
                        },
                        onUploadProgress: (progressEvent) => {
                            const fileUploadPercentage =
                                (progressEvent.loaded * 100) /
                                progressEvent.total;
                            const percentCompleted = Math.round(
                                fileUploadPercentage / 10
                            );

                            const status = {
                                message:
                                    'Uploading files for repository creation',
                                percentageCompletion: percentCompleted,
                                process: ProcessType.REPO_CREATION,
                                progress: TaskProgressType.PROCESSING,
                                repoId: null,
                                repoName: reponame,
                                statusCode: 200,
                                timeStamp: new Date(),
                                userMail: user.email,
                            };

                            props.socket.emit('statusUpdate', status);
                        },
                    })
                    .then(async (response) => {
                        if (response.data.message_alert) {
                            console.log(response.data.message_alert);
                        } else {
                            console.log(response.data.message);
                        }

                        await props.getAllReposData();
                    });
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    const errorMessage = error.response.data.error;
                    console.log(`${errorMessage}`);
                } else {
                    console.log(error.message);
                }
            }
        }); // end runSubmit callback
    };

    const onChangeOrganizationRepo = (checked) => {
        setOrganizationRepo(checked);
    };

    const onChangeVision = (checked) => {
        setVisionRepo(checked);
    };
    const handleSavePrompt = () => {
        // Save prompt only in state
        setLastPrompt(prompt);
        setPrompt(prompt);
        setIsPromptModalOpen(false);
    };

    const handleEditPromptClick = () => {
        setIsPromptModalOpen(true);
    };

    //knowledge graph
    const onChangeKnowledgeGraph = (checked) => {
        setKnowledgeGraph(checked);
    };

    const handleChange = (value, feature) => {
        if (
            isFeatureEnabled(
                [Features.ADD_NEW_REPOSITORY, feature],
                featureFlagsData
            )
        ) {
            if (
                (!isDatabaseRepo && value === 'database') ||
                (!isCloudRepo && value === 'cloud') ||
                (!isInternetRepo && value === 'internet')
            ) {
                setSelectedFiles([]); // Clear selected files when switching repo type
            }
            setIsDatabaseRepo(value === 'database');
            setIsCloudRepo(value === 'cloud');
            setIsInternetRepo(value === 'internet');
            setDefaultCheck(feature);
        }
    };

    const handleCategoryChange = (value) => {
        if (value === 'database') {
            setIsTabularRepo(false);
            setRepoCategory('database');
            handleChange('database', AddNewRepoFeatures.ADD_DATABASE);
            return;
        }
        if (value === 'tabular') {
            setSelectedFiles([]);
            setError('');
            setIsTabularRepo(true);
            setIsDatabaseRepo(false);
            setIsCloudRepo(false);
            setIsInternetRepo(false);
            setRepoCategory('tabular');
            setDefaultCheck(AddNewRepoFeatures.ADD_TABULAR);
            return;
        }

        setIsTabularRepo(false);
        if (repoCategory === 'tabular') {
            setSelectedFiles([]);
            setError('');
        }
        const contentFeature = CONTENT_REPO_FEATURES.includes(defaultCheck)
            ? defaultCheck
            : getFirstEnabledContentFeature();
        const contentValue = getFeatureValue(contentFeature);
        setRepoCategory('content');
        handleChange(contentValue, contentFeature);
    };

    const [isSmallScreen, setIsSmallScreen] = useState(
        window.innerWidth <= 1024
    );

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 568);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className='w-[90vw] min-w-[90px] md:w-[60vw] md:min-w-[500px] flex-col px-6 py-6 rounded-xl bg-backgrounds-slate'>
            <div className='relative flex flex-col w-full text-texts-secondary300'>
                <div className='mb-3'>
                    <Input
                        className=''
                        type='text'
                        placeholder='New repository name'
                        value={reponame}
                        onChange={(e) => {
                            const value = e.target.value;
                            // Charset gate rejects the keystroke outright.
                            if (!isValidNamingRegex(value, 0, 60)) {
                                setError(
                                    'Repository name can only contain letters, numbers, and underscores, and must be less than 60 characters.'
                                );
                                return;
                            }
                            setreponame(value);
                            // Validated here, in the parent that owns the input, so every
                            // tab inherits the result through the `error` prop.
                            if (!value) {
                                setError('');
                                return;
                            }
                            const nameCheck = validateRepoName(
                                value,
                                repoDetails
                            );
                            setError(nameCheck.valid ? '' : nameCheck.error);
                        }}
                        autoFocus
                    />
                </div>

                <Tabs
                    activeKey={repoCategory}
                    onChange={handleCategoryChange}
                    className='mb-3 add-new-repo-tabs'
                    items={[
                        ...(hasAnyContentFeature
                            ? [
                                  {
                                      key: 'content',
                                      label: (
                                          <span>
                                              <FontAwesomeIcon
                                                  icon={faFile}
                                                  className='mr-2'
                                              />
                                              Content
                                          </span>
                                      ),
                                      children: (
                                          <div className='flex flex-row mb-2 items-center'>
                                              <div className='text-texts-secondary300 mr-4 font-semibold'>
                                                  Content Source
                                              </div>
                                              <div className='flex flex-row flex-wrap items-center gap-x-4 gap-y-2'>
                                                  {isFeatureEnabled(
                                                      [
                                                          Features.ADD_NEW_REPOSITORY,
                                                          AddNewRepoFeatures.ADD_FILE,
                                                      ],
                                                      featureFlagsData
                                                  ) && (
                                                      <label className='flex items-center'>
                                                          <input
                                                              type='radio'
                                                              name='contentType'
                                                              value='file'
                                                              checked={
                                                                  defaultCheck ===
                                                                  AddNewRepoFeatures.ADD_FILE
                                                              }
                                                              className='mr-2'
                                                              onChange={(e) =>
                                                                  handleChange(
                                                                      e.target
                                                                          .value,
                                                                      AddNewRepoFeatures.ADD_FILE
                                                                  )
                                                              }
                                                          />
                                                          Files
                                                      </label>
                                                  )}

                                                  {isFeatureEnabled(
                                                      [
                                                          Features.ADD_NEW_REPOSITORY,
                                                          AddNewRepoFeatures.ADD_INTERNET,
                                                      ],
                                                      featureFlagsData
                                                  ) && (
                                                      <label className='flex items-center'>
                                                          <input
                                                              type='radio'
                                                              name='contentType'
                                                              value='internet'
                                                              checked={
                                                                  defaultCheck ===
                                                                  AddNewRepoFeatures.ADD_INTERNET
                                                              }
                                                              className='mr-2'
                                                              onChange={(e) =>
                                                                  handleChange(
                                                                      e.target
                                                                          .value,
                                                                      AddNewRepoFeatures.ADD_INTERNET
                                                                  )
                                                              }
                                                          />
                                                          URLs
                                                      </label>
                                                  )}

                                                  {isFeatureEnabled(
                                                      [
                                                          Features.ADD_NEW_REPOSITORY,
                                                          AddNewRepoFeatures.ADD_CLOUD,
                                                      ],
                                                      featureFlagsData
                                                  ) && (
                                                      <label className='flex items-center'>
                                                          <input
                                                              type='radio'
                                                              name='contentType'
                                                              value='cloud'
                                                              checked={
                                                                  defaultCheck ===
                                                                  AddNewRepoFeatures.ADD_CLOUD
                                                              }
                                                              className='mr-2'
                                                              onChange={(e) =>
                                                                  handleChange(
                                                                      e.target
                                                                          .value,
                                                                      AddNewRepoFeatures.ADD_CLOUD
                                                                  )
                                                              }
                                                          />
                                                          Cloud
                                                      </label>
                                                  )}
                                              </div>
                                          </div>
                                      ),
                                  },
                              ]
                            : []),
                        ...(isFeatureEnabled(
                            [
                                Features.ADD_NEW_REPOSITORY,
                                AddNewRepoFeatures.ADD_DATABASE,
                            ],
                            featureFlagsData
                        )
                            ? [
                                  {
                                      key: 'database',
                                      label: (
                                          <span>
                                              <FontAwesomeIcon
                                                  icon={faDatabase}
                                                  className='mr-2'
                                              />
                                              Database
                                          </span>
                                      ),
                                      children: null,
                                  },
                              ]
                            : []),
                        ...(isFeatureEnabled(
                            [
                                Features.ADD_NEW_REPOSITORY,
                                AddNewRepoFeatures.ADD_TABULAR,
                            ],
                            featureFlagsData
                        )
                            ? [
                                  {
                                      key: 'tabular',
                                      label: (
                                          <span>
                                              <FontAwesomeIcon
                                                  icon={faTable}
                                                  className='mr-2'
                                              />
                                              Tabular
                                          </span>
                                      ),
                                      children: null,
                                  },
                              ]
                            : []),
                    ]}
                />

                {repoCategory === 'content' &&
                isCloudRepo &&
                defaultCheck === AddNewRepoFeatures.ADD_CLOUD ? (
                    <AddCloudRepo
                        reponame={reponame}
                        setAddNewMode={props.setAddNewMode}
                        getAllReposData={props.getAllReposData}
                        socket={props.socket}
                        isAdmin={props.isAdmin}
                        visionRepo={visionRepo}
                        knowledgeGraph={knowledgeGraph}
                        onChangeVision={onChangeVision}
                        onChangeKnowledgeGraph={onChangeKnowledgeGraph}
                        visionModel={visionModel}
                        setVisionModel={setVisionModel}
                        embeddingModel={embeddingModel}
                        setEmbeddingModel={setEmbeddingModel}
                        imageResolution={imageResolution}
                        setImageResolution={setImageResolution}
                        imageResolutionDropdown={imageResolutionDropdown}
                        modelTierRepo={modelTierRepo}
                        isLoadingModels={isLoadingModels}
                        setModelTierRepo={setModelTierRepo}
                        availableCustomModels={availableCustomModels}
                        ModelTiers={ModelTiers}
                        availableEmbeddingModels={availableEmbeddingModels}
                        modelsLoading={modelsLoading}
                        error={error}
                        handleSubmit={handleSubmit}
                        user={user}
                    />
                ) : repoCategory === 'database' &&
                  isDatabaseRepo &&
                  defaultCheck === AddNewRepoFeatures.ADD_DATABASE ? (
                    <div>
                        <Maindbrepo
                            reponame={reponame}
                            setAddNewMode={props.setAddNewMode}
                            getAllReposData={props.getAllReposData}
                            socket={props.socket}
                            // So the database tabs gate on the same name validation.
                            error={error}
                            isNameFound={isNameFound}
                        ></Maindbrepo>
                        {/* Name validation runs in this parent for every tab, but the
                            database tabs only consumed `error` to disable their submit
                            button -- the reason was computed and never shown, so a
                            reserved/duplicate name just greyed the button out. */}
                        {error && (
                            <div className='flex justify-center items-center text-buttons-alert400 mt-3'>
                                <FontAwesomeIcon
                                    icon={faExclamationTriangle}
                                    className='mr-2'
                                />
                                {error}
                            </div>
                        )}
                    </div>
                ) : repoCategory === 'content' &&
                  isInternetRepo &&
                  defaultCheck === AddNewRepoFeatures.ADD_INTERNET ? (
                    <AddInternetRepo
                        reponame={reponame}
                        setAddNewMode={props.setAddNewMode}
                        getAllReposData={props.getAllReposData}
                        socket={props.socket}
                        setViewNotifications={props.setViewNotifications}
                        isAdmin={props.isAdmin}
                        visionRepo={visionRepo}
                        onChangeVision={onChangeVision}
                        visionModel={visionModel}
                        setVisionModel={setVisionModel}
                        embeddingModel={embeddingModel}
                        setEmbeddingModel={setEmbeddingModel}
                        error={error}
                        setError={setError}
                        isNameFound={isNameFound}
                        user={user}
                        imageResolution={imageResolution}
                        modelTierRepo={modelTierRepo}
                        isLoadingModels={isLoadingModels}
                        setModelTierRepo={setModelTierRepo}
                        availableCustomModels={availableCustomModels}
                        knowledgeGraph={knowledgeGraph}
                        setKnowledgeGraph={setKnowledgeGraph}
                        availableEmbeddingModels={availableEmbeddingModels}
                        modelsLoading={modelsLoading}
                    />
                ) : repoCategory === 'tabular' && isTabularRepo ? (
                    <form onSubmit={handleSubmit}>
                        <input
                            type='file'
                            className='bg-backgrounds-white w-full p-2 rounded-xl border cursor-pointer'
                            accept='.csv,.xlsx,.xls'
                            onClick={(e) => (e.target.value = null)}
                            onChange={(e) => {
                                const files = Array.from(e.target.files);
                                if (
                                    files.length > 0 &&
                                    validateTabularFiles(files)
                                ) {
                                    setSelectedFiles(files);
                                }
                            }}
                            ref={fileInputRef}
                        />
                        {!isMobile && (
                            <DragDropFile
                                text={
                                    "Drag and drop a single CSV or Excel file here or click on 'Choose Files' button to upload"
                                }
                                onDrop={handleTabularFileDrop}
                                onDragOver={handleDragOver}
                            />
                        )}
                        <div className='pt-4'>
                            <FileListViewer
                                className='mt-5'
                                selectedFiles={selectedFiles}
                            />
                        </div>

                        <div className='items-center justify-between mt-5 w-full'>
                            <RepoConfig
                                modelTierRepo={modelTierRepo}
                                setModelTierRepo={setModelTierRepo}
                                visionModel={visionModel}
                                setVisionModel={setVisionModel}
                                embeddingModel={embeddingModel}
                                setEmbeddingModel={setEmbeddingModel}
                                isLoadingModels={isLoadingModels}
                                availableCustomModels={availableCustomModels}
                                ModelTiers={ModelTiers}
                                isAdmin={props.isAdmin}
                                isOrganizationMember={
                                    props.isOrganizationMember
                                }
                                organizationRepo={organizationRepo}
                                onChangeOrganizationRepo={
                                    onChangeOrganizationRepo
                                }
                                availableEmbeddingModels={
                                    availableEmbeddingModels
                                }
                                modelsLoading={modelsLoading}
                            />
                        </div>
                        {error && (
                            <div className='flex justify-center items-center text-buttons-alert400 mt-3'>
                                <FontAwesomeIcon
                                    icon={faExclamationTriangle}
                                    className='mr-2'
                                />
                                {error}
                            </div>
                        )}
                        <div className='flex items-center justify-center mt-4'>
                            <div className='flex items-center justify-between w-full'>
                                <Button
                                    type='danger'
                                    icon={faCircleXmark}
                                    text={'Cancel'}
                                    tile={'Cancel and close the modal'}
                                    className='w-1/3'
                                    onClick={() => props.setAddNewMode(false)}
                                />
                                <SubmitButton
                                    icon={faFolderPlus}
                                    text='Add'
                                    submittingText='Creating...'
                                    isSubmitting={isSubmitting}
                                    disabled={
                                        !reponame ||
                                        error ||
                                        selectedFiles.length === 0
                                    }
                                    title='Upload file and add tabular repository'
                                />
                            </div>
                        </div>
                    </form>
                ) : (
                    <>
                        <form onSubmit={handleSubmit}>
                            <input
                                type='file'
                                className='bg-backgrounds-white w-full p-2 rounded-xl border cursor-pointer'
                                multiple
                                onClick={(e) => (e.target.value = null)}
                                onChange={handleFileSelect}
                                ref={fileInputRef}
                            />
                            {!isMobile && (
                                <DragDropFile
                                    text={
                                        "Drag and drop a file here or click on 'Choose Files' button to upload files"
                                    }
                                    onDrop={handleFileDrop}
                                    onDragOver={handleDragOver}
                                />
                            )}

                            <div className='pt-4'>
                                <FileListViewer
                                    className='mt-5'
                                    selectedFiles={selectedFiles}
                                />

                                {/* {false&& (
                                    <div className='flex justify-between items-center mt-3'>
                                        <div className='flex items-center justify-center mt-4'>
                                            <div className='mr-2 font-semibold text-texts-secondary300'>
                                                Vision Processing
                                            </div>
                                            <Switch
                                                checked={visionRepo}
                                                onChange={onChangeVision}
                                            />
                                        </div>
                                    </div>
                                )} */}
                                <div className='items-center justify-between mt-5 w-full'>
                                    {/* </div> */}
                                    <RepoConfig
                                        modelTierRepo={modelTierRepo}
                                        setModelTierRepo={setModelTierRepo}
                                        visionModel={visionModel}
                                        setVisionModel={setVisionModel}
                                        embeddingModel={embeddingModel}
                                        setEmbeddingModel={setEmbeddingModel}
                                        isLoadingModels={isLoadingModels}
                                        availableCustomModels={
                                            availableCustomModels
                                        }
                                        ModelTiers={ModelTiers}
                                        imageResolution={imageResolution}
                                        setImageResolution={setImageResolution}
                                        imageResolutionDropdown={
                                            imageResolutionDropdown
                                        }
                                        organizationRepo={organizationRepo}
                                        onChangeOrganizationRepo={
                                            onChangeOrganizationRepo
                                        }
                                        knowledgeGraph={knowledgeGraph}
                                        onChangeKnowledgeGraph={
                                            onChangeKnowledgeGraph
                                        }
                                        isAdmin={props.isAdmin}
                                        isOrganizationMember={
                                            props.isOrganizationMember
                                        }
                                        availableEmbeddingModels={
                                            availableEmbeddingModels
                                        }
                                        modelsLoading={modelsLoading}
                                    />

                                    {isPromptModalOpen && (
                                        <div className='fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center'>
                                            <div className='bg-white p-4 rounded-lg w-[90%] md:w-2/3 lg:w-1/2'>
                                                <h2 className='text-xl font-bold mb-4'>
                                                    Edit Vision Prompts
                                                </h2>

                                                {/* <label className='font-semibold'>
                                                    String Conversion Prompt
                                                </label>
                                                <textarea
                                                    value={
                                                        prompt.string_representation
                                                    }
                                                    onChange={(e) =>
                                                        setPrompt((prev) => ({
                                                            ...prev,
                                                            string_representation:
                                                                e.target.value,
                                                        }))
                                                    }
                                                    className='w-full h-48 p-2 border rounded mb-4'
                                                /> */}

                                                <label className='font-semibold'>
                                                    Vision Representation Prompt
                                                </label>
                                                <textarea
                                                    value={
                                                        prompt.instructions
                                                            .vision_representation ||
                                                        ''
                                                    }
                                                    onChange={(e) =>
                                                        setPrompt((prev) => ({
                                                            ...prev,
                                                            instructions: {
                                                                ...prev.instructions,
                                                                vision_representation:
                                                                    e.target
                                                                        .value,
                                                            },
                                                        }))
                                                    }
                                                    className='w-full h-48 p-2 border rounded mb-4'
                                                />

                                                <div className='flex justify-end gap-2'>
                                                    <button
                                                        className='px-4 py-2 rounded bg-gray-300 hover:bg-gray-400'
                                                        onClick={() => {
                                                            setIsPromptModalOpen(
                                                                false
                                                            );
                                                            setPrompt(
                                                                lastPrompt
                                                            );
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        className='px-4 py-2 rounded bg-green-500 text-white hover:bg-green-600'
                                                        onClick={
                                                            handleSavePrompt
                                                        }
                                                    >
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className='w-full flex items-center my-4'>
                                    {props.isAdmin && (
                                        <button
                                            type='button'
                                            onClick={handleEditPromptClick}
                                            className='flex items-center justify-center rounded-full py-1.5 px-2.5 rounded-lg order bg-backgrounds-white shadow-inner border font-semibold hover:bg-backgrounds-primary100 hover:border-backgrounds-primary200 text-backgrounds-primary300'
                                        >
                                            <FontAwesomeIcon
                                                icon={faPencil}
                                                className='mr-2'
                                            />
                                            Edit Vision Prompt
                                        </button>
                                    )}
                                </div>
                            </div>
                            {error && (
                                <div className='flex justify-center items-center text-buttons-alert400 mt-3'>
                                    <FontAwesomeIcon
                                        icon={faExclamationTriangle}
                                        className='mr-2'
                                    />
                                    {error}
                                </div>
                            )}
                            <div className='flex items-center justify-center mt-4'>
                                <div className='flex items-center justify-between w-full'>
                                    <Button
                                        type='danger'
                                        icon={faCircleXmark}
                                        text={'Cancel'}
                                        tile={'Cancel and close the modal'}
                                        className='w-1/3'
                                        onClick={() => {
                                            props.setAddNewMode(false);
                                        }}
                                    />

                                    <SubmitButton
                                        icon={faFolderPlus}
                                        text='Add'
                                        submittingText='Creating...'
                                        isSubmitting={isSubmitting}
                                        disabled={
                                            !reponame ||
                                            error ||
                                            selectedFiles.length === 0
                                        }
                                        title='Upload files and add new repository'
                                    />
                                </div>
                            </div>
                        </form>
                    </>
                )}
            </div>
            {WarningModal}
        </div>
    );
};

export default AddNewRepo;
